import axios from "axios";
import globalRouter from "./globalRouter";
import { deleteToken } from "./auth";
import { apiEndPoints } from "../variables/apiEndpoints";

const BASE_URL = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.url = `${BASE_URL}${config.url}`;
    const token = localStorage.getItem("user");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    if (
      error.response.status === 401 &&
      originalRequest.url !== `${BASE_URL}${apiEndPoints.login}`
    ) {
      deleteToken();
      typeof globalRouter?.navigate === "function" &&
        globalRouter.navigate("/login");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
